import React from 'react';
import AnimatedImage from '../Animations/AnimatedImage';

function RequiredField(props) {
    return (
        <AnimatedImage url="/images/required.svg" alt="required" />
    );
}

export default RequiredField;